import React, { useEffect, useState } from 'react';
import Render from './render';
import { fromAssets } from '../utils';

const CountryFlag = ({ phoneCodeId, phoneCodes, src }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (src) {
      setUrl(fromAssets(src));
    } else {
      const phone = phoneCodes?.find(x => x.value === phoneCodeId);
      const url = (phone && phone.url) ? fromAssets(phone.url) : null;
      setUrl(url || src);
    }
  }, [src, phoneCodeId, phoneCodes]);

  return (
    <Render condition={!!url}>
      <img className="w-6 h-6 object-contain" src={url} alt="Código de país" />
    </Render>
  )
}

export default CountryFlag